export const customTheme = {
  fonts: {
    heading: "Poppins",
    body: "Inter",
  },
};
